'use client';

import ListingContentlets from '@/components/shared/listingContentlets';
import { CollectionCard } from './collectionCard';

/**
 *
 *
 * @param {*} { posts }
 * @return {*}
 */
export const MostRecentBlock = ({ posts, contenttype }) => {
    return (
        <div className="flex flex-col pb-16 pt-8">
            <h4 className="text-2xl">Recommended</h4>
            <ListingContentlets
                Card={({ contentlet, ...props }) => (
                    <CollectionCard
                        contentlet={contentlet}
                        contenttype={contenttype}
                        showCategory={true}
                        {...props}
                    />
                )}
                contentlets={posts}
            />
        </div>
    );
};
